const ThailandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112536)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.756 13.043H1.24398C0.44 15.2096 0 17.553 0 19.9995C0 22.4459 0.44 24.7893 1.24398 26.9559H38.7561C39.56 24.7893 40 22.4459 40 19.9995C40 17.553 39.56 15.2096 38.756 13.043Z"
        fill="#0052B4"
      />
      <path
        d="M20.0004 0C13.9386 0 8.50709 2.69719 4.83936 6.95648H35.1613C31.4937 2.69719 26.0622 0 20.0004 0Z"
        fill="#D80027"
      />
      <path
        d="M35.1614 33.043H4.83936C8.50709 37.3023 13.9386 39.9995 20.0004 39.9995C26.0622 39.9995 31.4937 37.3023 35.1614 33.043Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112536">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ThailandSvg;
